jQuery(function () {
    var myOffside = offside("#mobileMenu", {
        slidingElementsSelector: "body",
        buttonsSelector: ".menu-toggle, .offcanvas-close, .offcanvas-overlay",
        beforeOpen: function () {
            $(".offcanvas-overlay").fadeIn();
        },
        beforeClose: function () {
            $(".offcanvas-overlay").fadeOut();
        },
    });

    var rellax = new Rellax('.rellax')

    $(window).on("scroll", function () {
        $("header").toggleClass("scrolling", $(window).scrollTop() > 0);
    });

    $(".scroll").click(function (e) {
        e.preventDefault();
        var id = $(this).attr("href").slice($(this).attr("href").indexOf('#'))
        scrollToElement(id, 2000);
    });

    AOS.init({
        disable: 'tablet',
        duration: 1200,
        offset: 50,
      });

    gallerySliderInit()
    shopHouseSliderInit()
    imageMapInit()
    facilityJS()
});

try {
    const menuLeftMapping = new MappingListener({
        selector: ".menu-wrapper-left",
        mobileWrapper: ".offcanvas-wrap",
        mobileMethod: "appendTo",
        desktopWrapper: ".header-left",
        desktopMethod: "appendTo",
        breakpoint: 1024.98,
    }).watch();
    const menuRightMapping = new MappingListener({
        selector: ".menu-wrapper-right",
        mobileWrapper: ".offcanvas-wrap",
        mobileMethod: "appendTo",
        desktopWrapper: ".header-right",
        desktopMethod: "prependTo",
        breakpoint: 1024.98,
    }).watch();
} catch (error) {}

var bannerSlider = new Swiper(".home-banner .swiper-container", {
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },
    loop: true,
    speed: 1300,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: ".home-banner .swiper-pagination",
        clickable: true,
    },
});

function gallerySliderInit() {
    var gallerySlider = new Swiper(
        ".gallery-slider .swiper-container",
        {
            spaceBetween: 15,
            pagination: {
                el: ".gallery-slider .swiper-pagination",
                clickable: true,
              },
        }
    );
}

function shopHouseSliderInit() {
    $(".shophouse-slider").each(function (index, ele) {
        var $this = $(this);
        $this.addClass("shophouse-slider-" + index);
        $this.find(".swiper-pagination").addClass("shophouse-pagination-" + index);
        var gallerySlider = new Swiper(
            ".shophouse-slider-" + index + " .swiper-container",
            {
                spaceBetween: 15,
                pagination: {
                    el: ".shophouse-pagination-" + index,
                    clickable: true,
                  },
            }
        );
    });
}

function imageMapInit() {
    $("map").imageMapResize()

    $("#imageMap").maphilight({
        fillColor: "c9822e",
        fillOpacity: 0.9,
        stroke: false,
        groupBy: "group",
    });

    $(".tooltip-v1").tooltipster({
        contentCloning: true,
        minWidth: 100,
        onlyOne: true,
        position: "bottom",
    });
}

function facilityJS() {
   
    $('.tab-nav a').on('click', function(e){
        e.preventDefault()
        var index = $(this).data('tab')
        $(this).parent().siblings().find('a').removeClass('text-gradient')
        $(this).addClass('text-gradient')
        $('.tab-content').hide()
        $(`.tab-content[data-tab=${index}]`).show()
    })

    var facilitySlider1 = new Swiper(
        ".slider-facility-1 .swiper-container",
        {
            spaceBetween: 15,
            pagination: {
                el: ".swiper-pagination-facility-1 .swiper-pagination",
                clickable: true,
              },
        }
    );

    var facilitySlider2 = new Swiper(
        ".slider-facility-2 .swiper-container",
        {
            spaceBetween: 15,
            pagination: {
                el: ".swiper-pagination-facility-2 .swiper-pagination",
                clickable: true,
              },
        }
    );

    $('.tab-content').hide()
    $('.tab-nav a').first().trigger('click')

}


var scrollToElement = function (el, ms) {
    var speed = ms ? ms : 2000;
    $("html,body").animate(
        {
            scrollTop: $(el).offset().top - $("header").height(),
        },
        speed
    );
};

